import { useEffect, useState } from "react";
// import "./CompetitionNew.css"; 
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchcompetition, STATUSES } from "../../../redux/getReducer/getCompetition";
import Animate from "../../../assets/loader.json";
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import RaceSectionTimer from "../../Reuseable/RaceSectionTimer";

const Competition = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState(false);
  const { data: competitionRes, status } = useSelector((state) => state.competition);
  const competition = competitionRes?.data || [];
  const [userIsDesktop, setUserIsDesktop] = useState(true);

  useEffect(() => {
    dispatch(fetchcompetition({ currentPage: 1, postsPerPage: 5 }));
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      window.innerWidth > 840 ? setUserIsDesktop(true) : setUserIsDesktop(false);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (status === STATUSES.LOADING) {
    return (
      <div className="new-loader-wrapper">
        <Lottie animationData={Animate} loop={true} className="new-comp-lottie" />
      </div>
    );
  }

  const cookiedata = Cookies.get("i18next");

  function HandleJockey(id) {
    if (userIsDesktop === true) {
      navigate("/race-detail?" + id);
    } else {
      navigate("/racedetails?" + id);
    }
  }

  return (
    <div className="saddle-battle-competition-wrapper w-100">
      <div className="new-competition-container">
        <div className="new-comp-header-box">
          <h2 className="new-comp-title">{t("competitionHeading")}</h2>
        </div>

        <div className="new-comp-body">
          {status === STATUSES.LOADING ? (
            <SkeletonTheme baseColor="#0d173d" highlightColor="#1a2b5e">
              <p className="new-sk-class"><Skeleton count={3} height={60} style={{ marginBottom: '15px' }} /></p>
            </SkeletonTheme>
          ) : !competition || competition.length === 0 ? (
            <div className="my-new-no-results-card" style={{ marginTop: '10px' }}>
              <div className="my-new-watermark-logo"></div>
              <p>{t("No Competition Available")}</p>
            </div>
          ) : (
            competition.map((item) => (
              item.CompetitionDataOfRaceV2.length !== 0 ? (
                <Accordion key={item._id} className="new-custom-accordion" defaultActiveKey="0">
                  <Accordion.Item eventKey="0" className="new-acc-item">

                    <Accordion.Header className="new-acc-header">
                      <div className="new-header-flex-wrapper">
                        <div className="flex-gap new-header-top-row py-2">
                          <span className="new-location-name">
                            {cookiedata === "en" ? item.NameEn : item.NameAr}
                          </span>
                          <span className="new-race-count-badge">
                            {item.CompetitionDataOfRaceV2.length} {t('Races')}
                          </span>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="new-acc-body custom-scrollbar">

                      {item.CompetitionDataOfRaceV2.map((data, index) => (
                        <div
                          key={index}
                          className="new-race-row"
                          onClick={() => HandleJockey(data.Race || data.RaceDataOfCompetitionV2?._id)}
                        >
                          <div className="new-race-info-side">
                            <span className="new-race-label">{t('Race')} {data.RaceDataOfCompetitionV2?.RaceNumber}</span>
                            <span className="new-race-name">
                              {data.RaceDataOfCompetitionV2?.RaceNameModelData ? (
                                cookiedata === "en" ? data.RaceDataOfCompetitionV2.RaceNameModelData.NameEn : data.RaceDataOfCompetitionV2.RaceNameModelData.NameAr
                              ) : "-"}
                            </span>
                          </div>
                          <div className="new-race-time-side">
                            <RaceSectionTimer
                              timer={data.RaceDataOfCompetitionV2?.TimeRemaining || "00:00:00"}
                              starttime={data.RaceDataOfCompetitionV2?.StartTime}
                              state={state}
                              setState={setState}
                            />
                          </div>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              ) : null
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Competition;